module.exports = __webpack_public_path__ + "3d88b6fa80fb775f66be86b170f7967b.svg";